export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/a70fe28c30edbe909cade8425716fdee.svg";